<template>
    <ProductCard @click="selectProduct" :pointer="!showWizard">
        <div :class="{'tw:grid tw:grid-cols-1 tw:md:grid-cols-3 tw:gap-0 tw:md:gap-8': showWizard}">
            <div class="tw:order-2 tw:md-order-1">
                <ProductImage :imageSrc="item.image" :altText="item.title" :cover="false" />
                <ProductDescription :title="item.title" :description="item.description" :tags="item.tags" />
                <ProductFooter>
                    <ProductPrice :price="item.price" :compareAt="item.compareAt" :deliveryFee="item.deliveryFee" />
                </ProductFooter>
            </div>
            <div v-if="showWizard" class="tw:col-span-2 tw:order-1 tw:md:order-2 tw:mb-4 tw:md:mb-0">
                <InlineBookingWizard/>
            </div>
        </div>
    </ProductCard>
</template>

<script setup>
	import ProductDescription from './product/description.vue'
	import ProductPrice from './product/price.vue'
    import ProductImage from './product/image.vue'
    import ProductCard from './product/cardWrapper.vue'
	import ProductFooter from './product/footerWrapper.vue'
    import InlineBookingWizard from './inlineBookingWizard.vue';
    import { useWebShopStore } from './webshopState'
    const webShopState = useWebShopStore()

	const { item, showWizard } = defineProps({
		item: { type: Object, required: true },
        showWizard: { type: Boolean, default: false },
	});

    const selectProduct = () => {
        webShopState.selectProduct(item)
    };
</script>

<style scoped>
</style>
